import { hasPushPermission } from "./hasPushPermission";

export const INSURANCE_ADHESION_PUSH_FUNCTION_KEYS = [
  "adesao_seguros",
  "Adesão de Seguros",
] as const;

export const INSURANCE_ADHESION_PUSH_LABEL = "Link Contratação via App";
export const INSURANCE_ADHESION_SAC_CARD_LABEL = "Contratar novo";
export const INSURANCE_ADHESION_SAC_MODAL_LABEL = "Contratar novo seguro";
export const INSURANCE_ADHESION_PUSH_TITLE =
  "Seu seguro está esperando por você";
export const INSURANCE_ADHESION_PUSH_DESCRIPTION =
  "Contrate agora sua proteção com praticidade e segurança. Acesse o app e garanta a cobertura ideal para o seu perfil. Toque aqui para começar.";
export const INSURANCE_ADHESION_PUSH_SUCCESS =
  "Link para contratação de seguro enviado com sucesso";
export const INSURANCE_ADHESION_PUSH_JOURNEY = "adesao_seguros";

export type InsuranceAdhesionActionVisibility = {
  showSacInsuranceAction: boolean;
  showPushInsuranceAction: boolean;
};

export function getInsuranceAdhesionActionVisibility({
  hasContractInsurancePermission,
  pushChannelEnabled,
  sacChannelEnabled,
}: {
  hasContractInsurancePermission: boolean;
  pushChannelEnabled: boolean;
  sacChannelEnabled: boolean;
}): InsuranceAdhesionActionVisibility {
  if (!hasContractInsurancePermission) {
    return {
      showSacInsuranceAction: false,
      showPushInsuranceAction: false,
    };
  }

  return {
    showSacInsuranceAction: Boolean(sacChannelEnabled),
    showPushInsuranceAction: Boolean(pushChannelEnabled),
  };
}

const hasInsuranceAdhesionChannel = (channel: "push" | "sac"): boolean =>
  INSURANCE_ADHESION_PUSH_FUNCTION_KEYS.some((functionKey) =>
    hasPushPermission(functionKey, channel)
  );

export function resolveInsuranceAdhesionActionVisibility(
  permissions?: string[] | null
): InsuranceAdhesionActionVisibility {
  return getInsuranceAdhesionActionVisibility({
    hasContractInsurancePermission: Boolean(
      permissions?.includes("insurance_Contract")
    ),
    pushChannelEnabled: hasInsuranceAdhesionChannel("push"),
    sacChannelEnabled: hasInsuranceAdhesionChannel("sac"),
  });
}
